// src/utils/pedidoItemConjuntoUtils.js

const getBooleanValue = (value) => value === true || value === 1 || value === '1';

const getPedidoItemConjuntoQtdItens = (conjunto) => {
  const qtdItens = Number(conjunto?.qtdItens ?? conjunto?.QtdItens ?? 1);

  return Number.isFinite(qtdItens) ? qtdItens : 1;
};

export const getPedidoItemConjuntoTotalQtdItens = (pedidoItemConjuntos = []) => {
  if (!Array.isArray(pedidoItemConjuntos)) {
    return 0;
  }

  return pedidoItemConjuntos.reduce((total, conjunto) => (
    total + getPedidoItemConjuntoQtdItens(conjunto)
  ), 0);
};

const getPedidoItemConjuntoGrupoKey = (conjunto) => (
  conjunto?.conjuntoId ?? conjunto?.ConjuntoId ?? conjunto?.nomeConjunto ?? conjunto?.NomeConjunto ?? null
);

const getPedidoItemConjuntoTotalDoMesmoGrupo = (conjunto, pedidoItemConjuntos = []) => {
  if (!Array.isArray(pedidoItemConjuntos)) {
    return 0;
  }

  const grupoKey = getPedidoItemConjuntoGrupoKey(conjunto);

  if (grupoKey === null) {
    return 0;
  }

  return pedidoItemConjuntos
    .filter((itemConjunto) => getPedidoItemConjuntoGrupoKey(itemConjunto) === grupoKey)
    .reduce((total, itemConjunto) => total + getPedidoItemConjuntoQtdItens(itemConjunto), 0);
};

export const getPedidoItemConjuntosAgrupados = (pedidoItemConjuntos = []) => {
  if (!Array.isArray(pedidoItemConjuntos)) {
    return [];
  }

  const agrupados = pedidoItemConjuntos.reduce((acc, conjunto) => {
    const nomeConjunto = conjunto.nomeConjunto || conjunto.NomeConjunto || 'Conjunto';

    if (!acc[nomeConjunto]) {
      acc[nomeConjunto] = [];
    }

    acc[nomeConjunto].push(conjunto);
    return acc;
  }, {});

  return Object.entries(agrupados).map(([nomeConjunto, itens]) => ({
    nomeConjunto,
    itens,
  }));
};

export const formatPedidoItemConjuntoQuantidade = (conjunto, pedidoItemConjuntos = []) => {
  const qtdItens = getPedidoItemConjuntoQtdItens(conjunto);
  const totalConjunto = getPedidoItemConjuntoTotalDoMesmoGrupo(conjunto, pedidoItemConjuntos);
  const usarFracao = getBooleanValue(conjunto?.usarFracao ?? conjunto?.UsarFracao);

  if (usarFracao && totalConjunto > 0) {
    return `${qtdItens}/${totalConjunto}`;
  }

  return `${qtdItens}x`;
};
